/** @jsx jsx */
import { jsx, Box, Flex } from 'theme-ui';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useQueryParam, StringParam } from 'use-query-params';

// Components
import CTAButton from '../ctaButton';
import Dropdown, { DropdownOption } from '../dropdown';
import Text, { TEXT_TYPES } from '../text';

// Styles
import { style } from './style';

export interface PartnerCategorySelectorOptions {
  label: string;
  value: string;
  slug: string;
  url?: string;
}

const optionAll = {
  label: 'All',
  value: 'all',
  slug: 'all',
};

export interface PartnerCategorySelectorProps {
  options: PartnerCategorySelectorOptions[];
  label?: string;
}

function sortByName(
  a: PartnerCategorySelectorOptions,
  b: PartnerCategorySelectorOptions,
) {
  return a.label.charCodeAt(0) - b.label.charCodeAt(0);
}

const PartnerCategorySelector: FunctionComponent<PartnerCategorySelectorProps> = React.memo(
  ({ options, label }) => {
    const [currentCat, setCurrentCat] = useQueryParam('cat', StringParam);
    const sortedOptions = [optionAll, ...options.sort(sortByName)] ?? [];

    // Handlers
    const handleDropdownOptionSelected = (
      _e: React.MouseEvent<any, MouseEvent>,
      option: DropdownOption,
    ): void => {
      if (!option?.slug) return;
      setCurrentCat(option.slug);
    };

    // Effects
    useEffect(() => {
      if (!currentCat) {
        setCurrentCat(optionAll.slug, 'replace');
      }
    }, []);

    return (
      <Box sx={style.mainContainer}>
        <Flex sx={style.containerMobile}>
          {label ? (
            <Text type={TEXT_TYPES.BODY_1} sx={{ mr: '16px' }}>
              {label}:
            </Text>
          ) : null}
          <Dropdown
            label={currentCat ?? ''}
            options={sortedOptions}
            disabled={options.length === 0}
            defaultValue={currentCat || ''}
            onSelect={handleDropdownOptionSelected}
          />
        </Flex>
      </Box>
    );
  },
);

export default PartnerCategorySelector;
